import dynamic from 'next/dynamic';
import settings from '@/settings';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import { getShortenCountryName } from '@/lib/use-origin-country';

const FrLegalNotice = dynamic(
  () => import('@/components/policies/legal-notice/FR'),
);

const DeLegalNotice = dynamic(
  () => import('@/components/policies/legal-notice/DE'),
);

const EsLegalNotice = dynamic(
  () => import('@/components/policies/legal-notice/ES'),
);

const ItLegalNotice = dynamic(
  () => import('@/components/policies/legal-notice/IT'),
);

const SeLegalNotice = dynamic(
  () => import('@/components/policies/legal-notice/SE'),
);

const IeLegalNotice = dynamic(
  () => import('@/components/policies/legal-notice/IE'),
);

const AtLegalNotice = dynamic(
  () => import('@/components/policies/legal-notice/AT'),
);

const UkLegalNotice = dynamic(
  () => import('@/components/policies/legal-notice/UK'),
);

const LegalNotice = () => {
  // Exclusive to reebelo-fr (Mentions Légales), reebelo-de (Impressum),
  // reebelo-es (Aviso Legal), reebelo-it (Avviso Legale), reebelo-se
  // (Juridisk information), reebelo-at (Impressum) and reebelo-uk (Legal Notice).
  if (settings.store === 'reebelo-uk') {
    return (
      <>
        <WebsiteSchema
          title={`Legal Notice - Reebelo ${getShortenCountryName()}`}
          description={`Legal notice for Reebelo ${settings.country}: company details, registration and VAT numbers, and the registered address for reebelo.co.uk.`}
        />
        <UkLegalNotice />
      </>
    );
  }

  if (settings.store === 'reebelo-de') {
    return (
      <>
        <WebsiteSchema
          title={`Impressum - Reebelo ${getShortenCountryName()}`}
          description={`Impressum von Reebelo ${settings.country}: Angaben zum Betreiber, Hosting-Anbieter und den Kontaktdaten der Website reebelo.de.`}
        />
        <DeLegalNotice />
      </>
    );
  }

  if (settings.store === 'reebelo-at') {
    return (
      <>
        <WebsiteSchema
          title={`Impressum - Reebelo ${getShortenCountryName()}`}
          description={`Impressum von Reebelo ${settings.country}: Angaben zum Betreiber, Hosting-Anbieter und den Kontaktdaten der Website reebelo.at.`}
        />
        <AtLegalNotice />
      </>
    );
  }

  if (settings.store === 'reebelo-es') {
    return (
      <>
        <WebsiteSchema
          title={`Aviso Legal - Reebelo ${getShortenCountryName()}`}
          description={`Aviso legal de Reebelo ${settings.country}: información sobre el editor, el proveedor de alojamiento y los datos de contacto del sitio reebelo.es.`}
        />
        <EsLegalNotice />
      </>
    );
  }

  if (settings.store === 'reebelo-it') {
    return (
      <>
        <WebsiteSchema
          title={`Avviso Legale - Reebelo ${getShortenCountryName()}`}
          description={`Avviso legale di Reebelo ${settings.country}: informazioni sull'editore, sul fornitore di hosting e sui recapiti del sito reebelo.it.`}
        />
        <ItLegalNotice />
      </>
    );
  }

  if (settings.store === 'reebelo-se') {
    return (
      <>
        <WebsiteSchema
          title={`Juridisk information - Reebelo ${getShortenCountryName()}`}
          description={`Juridisk information om Reebelo ${getShortenCountryName()}: uppgifter om utgivare, webbhotell och kontaktuppgifter för webbplatsen reebelo.se.`}
        />
        <SeLegalNotice />
      </>
    );
  }

  if (settings.store === 'reebelo-ie') {
    return (
      <>
        <WebsiteSchema
          title={`Legal Notice - Reebelo ${getShortenCountryName()}`}
          description={`Legal notice of Reebelo ${getShortenCountryName()}: details of the publisher, hosting provider and contact information for the reebelo.ie website.`}
        />
        <IeLegalNotice />
      </>
    );
  }

  if (settings.store !== 'reebelo-fr') {
    return null;
  }

  return (
    <>
      <WebsiteSchema
        title={`Mentions Légales - Reebelo ${getShortenCountryName()}`}
        description={`Mentions légales de Reebelo ${settings.country} : informations sur l’éditeur, l’hébergeur et les coordonnées du site reebelo.fr.`}
      />
      <FrLegalNotice />
    </>
  );
};

export default LegalNotice;
